import {skipToken} from '@reduxjs/toolkit/query';

import {isNilOrEmpty, isNotNil, isNotNilOrEmpty} from 'ramda-adjunct';

import {CustomerMessageResponseBody} from '@dms/api/core';
import {useGetCustomerV2Query, useGetUserQuery} from '@dms/api/customer';

import {getCustomerName} from '../../../utils/getCustomerName';

interface ThreadMessageAuthor {
  authorName: string | undefined;
}

// The avatar and name label of an SMS/WhatsApp bubble identify the message author: an incoming
// message is authored by the customer who contacted us, an outgoing one by the user (issuer) who
// sent it — resolved from senderId via useGetUserQuery, mirroring useThreadEmailHeader. When the
// issuer cannot be resolved (e.g. system/scheduled messages with no senderId) the name is empty and
// the Avatar falls back to its default person icon.
export function useThreadMessageAuthor(
  message: CustomerMessageResponseBody,
  showOutgoingRecipient = false
): ThreadMessageAuthor {
  const isOutgoing = message.direction === 'OUTGOING';

  const {data: customer} = useGetCustomerV2Query(
    {customerId: message.customerId ?? ''},
    {skip: isNilOrEmpty(message.customerId)}
  );

  const senderId = isOutgoing ? message.senderId : null;
  const {data: sender} = useGetUserQuery(isNotNil(senderId) ? {id: senderId} : skipToken);
  const senderName = [sender?.firstName, sender?.lastName].filter(isNotNilOrEmpty).join(' ');

  const authorName = isOutgoing && !showOutgoingRecipient ? senderName : getCustomerName(customer);

  return {authorName};
}
